import { render, staticRenderFns } from "./CampaignListTable.vue?vue&type=template&id=6e524f24&"
import script from "./CampaignListTable.vue?vue&type=script&lang=js&"
export * from "./CampaignListTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports